@if ($model() != null && canLoad) {
    <div class="working-area container hint-mode-reference px-2" (resized)="onResize($event)" (wheel)="onResize($event)" #pageContainerRef>
        <ngx-spinner name="flow" bdColor="#000000aa" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="true">
            <h6>Processando...</h6>
        </ngx-spinner>

        <div class="container-flex d-flex my-3">
            <!-- Telas de Detalhes -->
            <details-manager [_flowDefinition]="$flowDefinitionToEdit()"
                             [_isReadOnlyMode]="$isReadOnlyMode()"
                             [_isLatestVersion]="isLatestVersion"
                             [_isCreate]="isCreate"
                             [_openModalAreaTrigger]="$openModalAreaTrigger()"
                             [_toggleEditAreaTrigger]="$toggleEditAreaTrigger()"
                             (_activeDetailsTabEvent)="$activeDetailsTab.set($event)"
                             (_isAnyDetailsAreaOpenEvent)="$isAnyDetailsAreaOpen.set($event)"
                             (_isDetailsAreaExtraSizeEvent)="$isDetailsAreaExtraSize.set($event)"
                             (_openModalAreaTriggerResetEvent)="$openModalAreaTrigger.set(false)"
                             (_toggleEditAreaTriggerResetEvent)="$toggleEditAreaTrigger.set(null)"
                             (_saveFlowDefinitionEvent)="saveFlowDefinition()"
                             (_updateFlowObjectEvent)="updateFlowObject($event)"
                             (_updateFlowDefinitionEvent)="updateFlowDefinition($event)"
                             (_updateFlowDefinitionHotConfigsEvent)="updateFlowDefinition($event, true)"
            ></details-manager>

            <!-- Tarefas Disponíveis -->
            <div class="card library-area p-4 my-1 mx-0" #availableFlowObjectsParentRef
                 cdkDropList
                 cdkDropListSortingDisabled
                 [cdkDropListConnectedTo]="['flow-area-backdrop']"
                 [cdkDropListData]="$availableFlowObjects()"
                 [cdkDropListDisabled]="$hasGatewayPath()"
            >
                <div featureHint="availableFlowObjects">
                    <h5>Tarefas Disponíveis</h5>
                </div>

                <hr>

                <div class="available-flow-objects styled-scrollbar" [class.read-only]="$isReadOnlyMode()" #availableFlowObjectsRef>
                    <ngx-spinner bdColor="#f3f9fb" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>

                    @if ($isBootstrapFinished()) {
                        <div class="wrapper" #availableFlowObjectsWrapperRef>
                            @for (flowObject of $availableFlowObjects(); track flowObject) {
                                <available-flow-object [attr.featureHint]="getAvailableFlowObjectFeatureHint(flowObject)"
                                                       [_model]="flowObject"
                                                       [_isReadOnlyMode]="$isReadOnlyMode()"
                                                       [_hasGatewayPath]="$hasGatewayPath()"
                                                       [_hasFlowStarter]="$hasFlowStarter()"
                                                       [_firstGatewayPathName]="$firstGatewayPathName()"
                                                       [_secondGatewayPathName]="$secondGatewayPathName()"
                                                       (_selectFlowObjectEvent)="selectFlowObject($event.flowObject, $event.isFirstGatewayPath, $event.isSecondGatewayPath)"
                                                       (_dragStartedEvent)="dragStarted($event.event, $event.isAvailableFlowObject)"
                                                       (_dragEndedEvent)="dragEnded($event)"
                                                       (_dragMovedEvent)="dragMoved($event)"
                                ></available-flow-object>
                            }
                        </div>
                    }
                </div>
            </div>

            <!-- Flow Area -->
            <ng-container>
                <div class="card flow-area p-4 hidden" id="flow-area-backdrop" #flowAreaBackdropRef
                     cdkDropList
                     (cdkDropListDropped)="dragDropped($event)"
                ></div>

                <div class="card flow-area p-4 my-1 mx-0" #flowAreaRef
                     cdkDropList
                     cdkDropListOrientation="horizontal"
                     [cdkDropListData]="$selectedGroupings()"
                     (cdkDropListDropped)="dragDropped($event)"
                >
                    <!-- Somente Leitura -->
                    <div class="read-only-warning"
                         matTooltip="Esta versão do Fluxo encontra-se em modo &quot;Somente Leitura&quot; e nenhuma alteração de conteúdo será salva"
                         [class.on]="$isReadOnlyMode() && $activeDetailsTab() != Enums.DetailsAreaTabs.FlowDefinitionDetailsHotConfigs"
                         [class.details-on]="$isAnyDetailsAreaOpen()"
                         [class.wide]="$isDetailsAreaExtraSize()"
                    >
                        <i class="fas fa-glasses mr-2"></i>
                        <span>Somente Leitura</span>
                    </div>

                    <!-- Canvas Header -->
                    <canvas-header [_flowDefinition]="$model()"
                                   [_isReadOnlyMode]="$isReadOnlyMode()"
                                   [_isCreate]="isCreate"
                                   [_hasTemporalHotConfigs]="$hasTemporalHotConfigs()"
                                   [_changeVersionTrigger]="$changeVersionTrigger()"
                                   [_selectedVersion]="$selectedVersion()"
                                   [_selectedFlowObjectsLength]="$selectedFlowObjects().length"
                                   (_saveFlowDefinitionEvent)="saveFlowDefinition()"
                                   (_openModalAreaTriggerEvent)="$openModalAreaTrigger.set(true)"
                                   (_changeVersionTriggerResetEvent)="$changeVersionTrigger.set(false)"
                    ></canvas-header>

                    <hr>

                    <!-- Canvas Body -->
                    <canvas-body [_isBootstrapFinished]="$isBootstrapFinished()"
                                 [_isReadOnlyMode]="$isReadOnlyMode()"
                                 [_selectedFlowObjects]="$selectedFlowObjects()"
                                 [_selectedGroupings]="$selectedGroupings()"
                                 [_selectedGroupingColumns]="$selectedGroupingColumns()"
                                 [_selectedVersion]="$selectedVersion()"
                                 [_clearLinksTrigger]="$clearLinksTrigger()"
                                 [_linkFlowObjectsTrigger]="$linkFlowObjectsTrigger()"
                                 [_reorderFlowObjectsTrigger]="$reorderFlowObjectsTrigger()"
                                 [_onAfterSelectFlowObjectTrigger]="$onAfterSelectFlowObjectTrigger()"
                                 (_selectedFlowObjectsChangeEvent)="Utils.setSignal($selectedFlowObjects, $event)"
                                 (_selectedGroupingsChangeEvent)="Utils.setSignal($selectedGroupings, $event)"
                                 (_selectedGroupingColumnsChangeEvent)="Utils.setSignal($selectedGroupingColumns, $event)"
                                 (_toggleEditAreaEvent)="Utils.setSignal($toggleEditAreaTrigger, $event)"
                                 (_clearLinksTriggerResetEvent)="$clearLinksTrigger.set(false)"
                                 (_linkFlowObjectsTriggerResetEvent)="$linkFlowObjectsTrigger.set(false)"
                                 (_reorderFlowObjectsTriggerResetEvent)="$reorderFlowObjectsTrigger.set(false)"
                                 (_onAfterSelectFlowObjectTriggerResetEvent)="$onAfterSelectFlowObjectTrigger.set(null)"
                    ></canvas-body>
                </div>
            </ng-container>
        </div>
    </div>
}
